/* ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
   Wicked Rewards — split-flap count-up animation
   ---------------------------------------------------------------
   - Reads the target value from data-target on .wr__flaps
   - Animates each digit from 0 → target over ~1.5s
   - Respects prefers-reduced-motion
   - Idempotent: safe to load on every page; no-ops if no .wr__flaps
   ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━ */

(function () {
  'use strict';

  // Public override hook for loyalty apps that fetch points async.
  // After your app fetches the balance, call:
  //   window.WickedRewards.setPoints(1240);
  // to retrigger the animation with a real value.
  window.WickedRewards = window.WickedRewards || {};
  window.WickedRewards.setPoints = function (n) {
    document.querySelectorAll('.wr__flaps').forEach(function (el) {
      el.dataset.target = String(n);
      animate(el);
    });
  };

  var DURATION = 1500;
  var DIGITS = 4;
  var reducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setDigits(el, value) {
    var padded = String(Math.max(0, Math.floor(value))).padStart(DIGITS, '0');
    var flaps = el.querySelectorAll('.wr__flap');
    for (var i = 0; i < flaps.length && i < padded.length; i++) {
      if (flaps[i].textContent !== padded[i]) {
        flaps[i].textContent = padded[i];
      }
    }
  }

  function animate(el) {
    var target = parseInt(el.dataset.target, 10) || 0;

    if (reducedMotion || target === 0) {
      setDigits(el, target);
      return;
    }

    // Cancel any previous animation on this element
    if (el._wrTimer) clearTimeout(el._wrTimer);

    setDigits(el, 0);
    var t0 = Date.now();

    function step() {
      var p = Math.min(1, (Date.now() - t0) / DURATION);
      var eased = 1 - Math.pow(1 - p, 3);
      setDigits(el, Math.round(target * eased));
      if (p < 1) {
        el._wrTimer = setTimeout(step, 1000 / 60);
      }
    }
    // Defer first step ~30ms so the page paints "0000" first.
    el._wrTimer = setTimeout(step, 30);
  }

  function init() {
    document.querySelectorAll('.wr__flaps').forEach(animate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
